import * as types from "./actions";

const defaultState = {
    list: [],
    tableHeader:[
        {
            label: "取引先コード（主番）", 
            center: true,            
            rightAlign: true
        },
        {
            label: "取引先コード（枝番）", 
            center: true,   
            rightAlign: true
        },
        {
            label: "取引先名", 
            center: true,   
        },
        {
            label: "商品数", 
            center: true,   
            rightAlign: true
        },
        {
            label: "受注数", 
            center: true,   
            rightAlign: true
        },
        {
            label: "明細",
            button:true
        },
    ],
    tableColumns:[
        "shopMainNumber",
        "shopBranchNumber",
        "shopName",
        "products",
        "totalProducts"
    ],
    
}

export default function reducer (state=defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return {...state, list: action.payload};
        default: // need this for default case
            return state 
    }
};
